function generateDailyData(employeeDetails, infoData, duration) {
  const start = new Date(duration.startDate);
  const end = new Date(duration.endDate);

  const result = [];

  employeeDetails.forEach((emp) => {
    const days = [];

    for (
      let date = new Date(start);
      date <= end;
      date.setDate(date.getDate() + 1)
    ) {
      const formattedDate = date.toISOString().split("T")[0];

      // ====================
      // Generate base values
      // ====================

      // accounts: 2 to 15
      const accounts = Math.floor(Math.random() * 14) + 2;

      // contacts: accounts * (2 to 5)
      const contacts = accounts * (Math.floor(Math.random() * 4) + 2);

      // jobOpenings: same as accounts OR accounts + (2 to 4)
      const jobOpenings =
        Math.random() > 0.5
          ? accounts
          : accounts + (Math.floor(Math.random() * 3) + 2);

      // confirm: between 0 and jobOpenings
      const confirm = Math.floor(Math.random() * (jobOpenings + 1));

      days.push({
        date: formattedDate,
        info: {
          contacts,
          accounts,
          jobOpenings,
          confirm,
        },
      });
    }

    result.push({
      employeeId: emp.id,
      name: emp.name,
      managerId: emp.managerId,
      records: days,
    });
  });

  return result;
}

const employeeDetails = [
  // =====================
  // Managers (managerId = "0")
  // =====================
  {
    id: 1,
    name: "John Manager",
    email: "john.manager@example.com",
    managerId: "0",
  },
  {
    id: 2,
    name: "Sarah Manager",
    email: "sarah.manager@example.com",
    managerId: "0",
  },
  {
    id: 3,
    name: "Robert Manager",
    email: "robert.manager@example.com",
    managerId: "0",
  },
  // =====================
  // Employees under Manager 1 (id = 1)
  // =====================
  {
    id: 4,
    name: "Emily Johnson",
    email: "emily.johnson@example.com",
    managerId: "1",
  },
  {
    id: 5,
    name: "Michael Brown",
    email: "michael.brown@example.com",
    managerId: "1",
  },
  {
    id: 6,
    name: "David Wilson",
    email: "david.wilson@example.com",
    managerId: "1",
  },
  {
    id: 7,
    name: "Sophia Miller",
    email: "sophia.miller@example.com",
    managerId: "1",
  },
  {
    id: 8,
    name: "Ethan Davis",
    email: "ethan.davis@example.com",
    managerId: "1",
  },
  {
    id: 9,
    name: "Ava Thompson",
    email: "ava.thompson@example.com",
    managerId: "1",
  },
  {
    id: 10,
    name: "Daniel Martinez",
    email: "daniel.martinez@example.com",
    managerId: "1",
  },

  // // =====================
  // // Employees under Manager 2 (id = 2)
  // // =====================
  // {
  //   id: 11,
  //   name: "Olivia Anderson",
  //   email: "olivia.anderson@example.com",
  //   managerId: "2",
  // },
  // {
  //   id: 12,
  //   name: "James Taylor",
  //   email: "james.taylor@example.com",
  //   managerId: "2",
  // },
  // {
  //   id: 13,
  //   name: "Isabella Moore",
  //   email: "isabella.moore@example.com",
  //   managerId: "2",
  // },
  // {
  //   id: 14,
  //   name: "Benjamin Jackson",
  //   email: "benjamin.jackson@example.com",
  //   managerId: "2",
  // },
  // {
  //   id: 15,
  //   name: "Mia White",
  //   email: "mia.white@example.com",
  //   managerId: "2",
  // },
  // {
  //   id: 16,
  //   name: "Logan Harris",
  //   email: "logan.harris@example.com",
  //   managerId: "2",
  // },
  // {
  //   id: 17,
  //   name: "Ella Clark",
  //   email: "ella.clark@example.com",
  //   managerId: "2",
  // },
  // {
  //   id: 18,
  //   name: "Henry Lewis",
  //   email: "henry.lewis@example.com",
  //   managerId: "2",
  // },

  // // =====================
  // // Employees under Manager 3 (id = 3)
  // // =====================
  // {
  //   id: 19,
  //   name: "Chloe Walker",
  //   email: "chloe.walker@example.com",
  //   managerId: "3",
  // },
  // {
  //   id: 20,
  //   name: "Sebastian Hall",
  //   email: "sebastian.hall@example.com",
  //   managerId: "3",
  // },
  // {
  //   id: 21,
  //   name: "Grace King",
  //   email: "grace.king@example.com",
  //   managerId: "3",
  // },
  // {
  //   id: 22,
  //   name: "Jack Wright",
  //   email: "jack.wright@example.com",
  //   managerId: "3",
  // },
  // {
  //   id: 23,
  //   name: "Lily Scott",
  //   email: "lily.scott@example.com",
  //   managerId: "3",
  // },
  // {
  //   id: 24,
  //   name: "Samuel Green",
  //   email: "samuel.green@example.com",
  //   managerId: "3",
  // },
  // {
  //   id: 25,
  //   name: "Zoe Adams",
  //   email: "zoe.adams@example.com",
  //   managerId: "3",
  // },
  // {
  //   id: 26,
  //   name: "Matthew Baker",
  //   email: "matthew.baker@example.com",
  //   managerId: "3",
  // },
];

const duration = {
  startDate: "2025-01-01",
  endDate: "2025-11-30",
  // endDate: new Date().toISOString().split("T")[0], // today,
};

const infoData = ["contacts", "accounts", "jobOpenings", "confirm"];

const data = generateDailyData(employeeDetails, infoData, duration);

function getDurtionAsCategory() {
  const startDate = new Date(duration.startDate);
  const endDate = new Date(duration.endDate);
  const categories = [];
  const cursor = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
  const last = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
  while (cursor <= last) {
    categories.push(
      cursor.toLocaleDateString("en-US", {
        month: "short",
        year: "numeric",
      })
    );
    cursor.setMonth(cursor.getMonth() + 1);
  }
  return categories;
}

const categories = getDurtionAsCategory();

///// now time to generate series here name is employee name and data is monthly contacts
function getSeries({ infoType }) {
  const cats = categories; // month-year labels
  const series = data.map((emp) => {
    const totals = new Map();
    for (const rec of emp.records) {
      const key = new Date(rec.date).toLocaleDateString("en-US", {
        month: "short",
        year: "numeric",
      });
      const val = rec.info?.[infoType] ?? 0;
      totals.set(key, (totals.get(key) || 0) + val);
    }
    const arr = cats.map((k) => totals.get(k) || 0);
    return { name: emp.name, data: arr };
  });
  return series;
}
const seriesContacts = getSeries({ infoType: "contacts" });
const seriesAccounts = getSeries({ infoType: "accounts" });

function seriesAccountsPie({ infoType }) {
  const labels = employeeDetails.map((e) => e.name);
  const totalsPerEmp = employeeDetails.map((e) => {
    const emp = data.find((d) => d.employeeId === e.id);
    if (!emp) return 0;
    let sum = 0;
    for (const rec of emp.records) {
      const v = rec?.info?.[infoType];
      if (typeof v === "number") sum += v;
    }
    return sum;
  });
  return { labels, values: totalsPerEmp };
}

export { data, seriesContacts, categories, seriesAccounts, seriesAccountsPie };

function getGroupedStackSeries(infoTypes = infoData) {
  const cats = categories;
  const series = [];
  data.forEach((emp) => {
    const totalsByType = {};
    infoTypes.forEach((t) => (totalsByType[t] = new Map()));
    for (const rec of emp.records) {
      const key = new Date(rec.date).toLocaleDateString("en-US", {
        month: "short",
        year: "numeric",
      });
      infoTypes.forEach((t) => {
        const v = rec.info?.[t] ?? 0;
        totalsByType[t].set(key, (totalsByType[t].get(key) || 0) + v);
      });
    }
    infoTypes.forEach((t) => {
      const arr = cats.map((k) => totalsByType[t].get(k) || 0);
      const niceName =
        t === "jobOpenings"
          ? "Job Openings"
          : t === "contacts"
          ? "Contacts"
          : t === "accounts"
          ? "Accounts"
          : t === "confirm"
          ? "Confirm"
          : String(t);
      series.push({ name: niceName, group: emp.name, data: arr });
    });
  });
  return series;
}

export { getGroupedStackSeries };
